export const QUERY_KEY = Object.freeze({
  homeNotice: 'homeNotice',
  banner: 'banner',
  attendance: 'monthlyAttendanceHistory',
  search: 'search',
  post: (postId) => (postId ? ['post', postId] : ['post']),
  posts: 'posts',
  review: 'review',
  reviews: 'reviews',
  reviewWritePeriodActive: 'reviewWritePeriodActive',
  comments: 'comments',
  noticeLine: 'noticeLine',
  notices: 'notices',
  pointHistory: 'pointHistory',
  userInfo: 'userInfo',
  myPosts: 'myPosts',
  myCommentedPosts: 'myCommentedPosts',
  myDownloadedExamReviews: 'myDownloadedExamReviews',
  myInquiriesAndReports: 'myInquiriesAndReports',
  myScrapedPosts: 'myScrapedPosts',
  myScrapedExamReviews: 'myScrapedExamReviews',
  best3: 'best3',
  notifications: (category) =>
    category ? ['notifications', { category }] : ['notifications'],
  unreadNotificationCount: ['unreadNotificationCount'],
  notificationSettings: ['notificationSettings'],
  events: 'events',
  commerceSale: (saleId) => ['commerceSale', saleId],
  commerceOrders: ['commerceOrders'],
  commerceOrder: (orderNumber) => ['commerceOrder', orderNumber],
  commercePickupDeviceSession: ['commercePickupDeviceSession'],
});

export const MUTATION_KEY = Object.freeze({
  editPost: 'editPost',
  createExamReview: 'createExamReview',
  deleteExamReview: 'deleteExamReview',
  editExamReview: 'editExamReview',
  createComment: 'createComment',
  deleteComment: 'deleteComment',
  editComment: 'editComment',
  reportPost: 'reportPost',
  reportUser: 'reportUser',
  reportComment: 'reportComment',
  like: 'like',
  unlike: 'unlike',
  scrap: 'scrap',
  unscrap: 'unscrap',
  updateUserInfo: 'updateUserInfo',
  updatePassword: 'updatePassword',
  readNotifications: ['readNotifications', 'single'],
  readAllNotifications: ['readNotifications', 'all'],
  updateNotificationSettings: ['updateNotificationSettings'],
  updateCommentNotificationSetting: ['updateCommentNotificationSetting'],
});

export const STALE_TIME = Object.freeze({
  examReview: 1000 * 60 * 5,
  reviewWritePeriodActive: 1000 * 60 * 5,
  boardPostList: 1000 * 60 * 1,
  mypageActivity: 1000 * 60 * 5,
  noticeList: 1000 * 60 * 10,
  searchList: 1000 * 60 * 10,
  noticeLine: 1000 * 60 * 10,
});
